/**
 * A ruled list of records that carry their own controls: a staff member with role boxes and a
 * Remove button, an ingredient with a dose box. The shared `List` rows are for records that are
 * one link, and a row holding controls cannot be a link.
 */
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { border, space } from "@lattice/tokens/space.stylex";
import { Text } from "@lattice/ui/Text";
export function RecordList({
  label,
  testId,
  children
}: {
  readonly label: string;
  readonly testId?: string;
  readonly children: ReactNode;
}) {
  return <ul aria-label={label} data-testid={testId} className="xe8uvvx x1ghz6dp x1717udv x78zum5 xdt5ytf">
      {children}
    </ul>;
}
export function RecordRow({
  title,
  detail,
  trailing,
  testId,
  children
}: {
  readonly title: string;
  /** Who or what the record is, under its name. */
  readonly detail?: string | undefined;
  /** What sits beside the name: a dose, a status. */
  readonly trailing?: ReactNode;
  readonly testId?: string;
  /** The controls and messages that belong to this record. */
  readonly children?: ReactNode;
}) {
  return <li data-testid={testId} className="x78zum5 xdt5ytf x1173whf xp1t01x xq3vdme x1q0q8m5 x10xjq5j">
      <div className="x78zum5 x1a02dak x6s0dn4 x1qughib x626il7">
        <div className="x78zum5 xdt5ytf xskm3c9 xeuugli">
          <span className="xj0a0fe">
            <Text as="span" variant="label">
              {title}
            </Text>
          </span>
          {detail === undefined ? null : <Text as="span" variant="caption" tone="secondary">
              {detail}
            </Text>}
        </div>
        {trailing === undefined ? null : <RecordControls>{trailing}</RecordControls>}
      </div>
      {children}
    </li>;
}

/** The controls of one record, wrapping onto a second line on a phone. */
export function RecordControls({
  children
}: {
  readonly children: ReactNode;
}) {
  return <div className="x78zum5 x1a02dak x6s0dn4 x626il7">{children}</div>;
}